

import React, { useState, useEffect } from "react";
import "./swiper.css";
import "./chat_add.css";
import "./chat.css";
// import "./swiper.js";
import { PAconnectorChatSlack } from "../PAconnectors";

import {
  InputCopy,
  Select,
  StatusDot,
  Subheader,
  Head,
  Card,
  Collapse,
  Textarea,
  ContentBlock,
  RadioGroup,
  Switch,
  ButtonAction,
  Tag,
  Notification,
  CheckboxGroup,
} from "xsolla-uikit";
import {
  BrowserRouter as Router,
  useLocation,
  withRouter,
  Link,
} from "react-router-dom";

import styled from "styled-components";

import PAh2 from "../PAh2";
import { ChatTrigger } from "./ChatTrigger";
import { ChatBody } from "./ChatBody";

export function Chat() {
  const [shown, setShown] = useState();

  const [apiKey, setApiKey] = useState();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  if (query && query.get("APIKEY") && !apiKey) {
    console.log(query.get("APIKEY"))
    setApiKey(query.get("APIKEY"))
  }


  const Webflow = require('webflow-api');

  let api;
  useEffect(() => {
    if (apiKey) {
      api = new Webflow({ token: apiKey });
      api.info()
      .then(info => console.log(info))
    }
  }, [apiKey])


  return (
    <div className="xsb_how">
      <ChatBody shown={shown} handle={() => setShown(!shown)} />

      <ChatTrigger shown={shown} handle={() => setShown(!shown)} />
    </div>
  );
}




export const faqs = [
  {
    id: "gall",
    video: "https://www.youtube.com/embed/Hzns5hpF8Ug",
    title: "Change colors",
    description:
      "You can change global colors theme for your Landing page, Emails",
    new: true,
    highlighted: true,
  },
  {
    id: "gall2",
    video: "https://www.youtube.com/embed/a70LK85fNKY",
    title: "Access new gamers",
    description:
      "Get matched up with influencers through this powerful tool that lets you acquire new players for your game. Reach over 650,000 influencers and 1.25B audience",
    new: true,
    highlighted: false,
  },
  {
    id: "seo",
    video: "https://www.youtube.com/embed/xg04wRFgHL8",
    title: "Unity Store SDK",
    description:
      "Xsolla In-Game Store lets your team integrate in-app purchases, and sell virtual goods to a worldwide audience. This video will show you step-by-step how to get started!",
    new: true,
    highlighted: false,
  },
  {
    id: "an",
    video: "https://www.youtube.com/embed/4bplblWot-o",
    title: "Mobile Store",
    description:
      "Xsolla Mobile-Out Store allows developers to port their in-game mobile stores to PC and web without writing a single line of code and with no additional development, storage, or operation fees.",
    new: true,
    highlighted: true,
  },
  // {
  //   'id': 'dom',
  //   'video': 'https://www.youtube.com/embed/JYeLtMvgyPg',
  //   'title': 'Own domain',
  //   'new': true,
  //   'highlighted': false,
  // },
  // {
  //   'id': 'img',
  //   'video': 'https://www.youtube.com/embed/JYeLtMvgyPg',
  //   'title': 'Tweaking an Image',
  //   'new': true,
  //   'highlighted': false,
  // },
  // {
  //   'id': 'vid',
  //   'video': 'https://www.youtube.com/embed/3gPsLA-dwNM',
  //   'title': 'Video Recomendations',
  //   'new': true,
  //   'highlighted': false,
  // },
  // {
  //   'id': 'clr',
  //   'video': 'https://www.youtube.com/embed/JYeLtMvgyPg',
  //   'title': 'Clear image',
  //   'new': true,
  //   'highlighted': false,
  // },
];
